// Shared theme presets for commercial proposals (used in editor + public view)
export const BG_PRESETS = [
  { id: "pink-glow", label: "Pink Glow", subtitle: "INFLUCAST signature · dark", mode: "dark" },
  { id: "dark-solid", label: "Dark Solid", subtitle: "Negro plano minimalista", mode: "dark" },
  { id: "grid", label: "Grid Tech", subtitle: "Negro con grid sutil", mode: "dark" },
  { id: "mesh-pop", label: "Mesh Pop", subtitle: "Multicolor vibrante", mode: "dark" },
  { id: "gradient-sunset", label: "Sunset", subtitle: "Rosa → Naranja", mode: "dark" },
  { id: "gradient-ocean", label: "Ocean", subtitle: "Azul → Cyan", mode: "dark" },
  { id: "gradient-violet", label: "Violet", subtitle: "Violeta → Magenta", mode: "dark" },
  { id: "custom-gradient", label: "Custom Gradient", subtitle: "Tus dos colores", mode: "dark" },
  { id: "light-solid", label: "Light Solid", subtitle: "Crema minimalista", mode: "light" },
  { id: "light-grid", label: "Light Grid", subtitle: "Crema con grid", mode: "light" },
  { id: "cover", label: "Foto de portada", subtitle: "Imagen full bleed", mode: "dark" },
];

export const FONT_HEADINGS = ["Unbounded", "Sora", "Bebas Neue", "Space Grotesk", "Anton"];
export const FONT_BODIES = ["Manrope", "Inter", "DM Sans", "Plus Jakarta Sans"];

export function buildPageStyles({ preset, mode, accent, gFrom, gTo, bgColor }) {
  const isLight = mode === "light";
  const baseBg = bgColor || (isLight ? "#F5F2EC" : "#050505");
  const styles = {
    "--p-bg": baseBg,
    "--p-fg": isLight ? "#0a0a0a" : "#ffffff",
    "--p-fg-soft": isLight ? "rgba(10,10,10,0.72)" : "rgba(255,255,255,0.78)",
    "--p-fg-muted": isLight ? "rgba(10,10,10,0.45)" : "rgba(255,255,255,0.5)",
    "--p-border": isLight ? "rgba(0,0,0,0.12)" : "rgba(255,255,255,0.12)",
    "--p-card": isLight ? "rgba(255,255,255,0.6)" : "rgba(255,255,255,0.03)",
    "--p-accent": accent || "#FF0055",
    "--p-grad-to": gTo || "#0EE6CB",
  };
  let bg = `background:${baseBg};`;
  switch (preset) {
    case "pink-glow":
      bg = `background:${baseBg};background-image:radial-gradient(circle at 12% 18%, ${accent}55 0%, transparent 38%),radial-gradient(circle at 88% 82%, #0EE6CB30 0%, transparent 40%);`;
      break;
    case "grid":
      bg = `background:${baseBg};background-image:linear-gradient(rgba(255,255,255,0.06) 1px, transparent 1px),linear-gradient(90deg, rgba(255,255,255,0.06) 1px, transparent 1px);background-size:64px 64px;`;
      break;
    case "light-grid":
      bg = `background:#FAF7F1;background-image:linear-gradient(rgba(0,0,0,0.06) 1px, transparent 1px),linear-gradient(90deg, rgba(0,0,0,0.06) 1px, transparent 1px);background-size:64px 64px;`;
      break;
    case "gradient-sunset":
      bg = `background:linear-gradient(135deg, #FF0055 0%, #FF6B35 50%, #FFB72B 100%);`;
      break;
    case "gradient-ocean":
      bg = `background:linear-gradient(135deg, #0E2148 0%, #483AA0 45%, #0EE6CB 100%);`;
      break;
    case "gradient-violet":
      bg = `background:linear-gradient(135deg, #2D1B69 0%, #8B2FC9 55%, #FF0055 100%);`;
      break;
    case "mesh-pop":
      bg = `background:${baseBg};background-image:radial-gradient(at 18% 24%, #FF0055 0%, transparent 45%),radial-gradient(at 82% 18%, #0EE6CB 0%, transparent 45%),radial-gradient(at 50% 88%, #FFB72B 0%, transparent 45%),radial-gradient(at 12% 78%, #8B2FC9 0%, transparent 45%);`;
      break;
    case "custom-gradient":
      bg = `background:linear-gradient(135deg, ${gFrom || accent} 0%, ${gTo || "#0EE6CB"} 100%);`;
      break;
    case "light-solid":
      bg = `background:${bgColor || "#F5F2EC"};`;
      break;
    case "cover":
      bg = `background:${baseBg};`;
      break;
    default:
      bg = `background:${baseBg};`;
  }
  return { vars: styles, bgCss: bg, isLight };
}

const FONT_LINK_ID = "influcast-proposal-fonts";
export function ensureProposalFontsLoaded() {
  if (typeof document === "undefined") return;
  if (document.getElementById(FONT_LINK_ID)) return;
  const link = document.createElement("link");
  link.id = FONT_LINK_ID;
  link.rel = "stylesheet";
  link.href =
    "https://fonts.googleapis.com/css2?" +
    "family=Unbounded:wght@400;600;800;900" +
    "&family=Manrope:wght@300;400;500;600;700;800" +
    "&family=Sora:wght@400;700;800" +
    "&family=Bebas+Neue" +
    "&family=Space+Grotesk:wght@400;600;700" +
    "&family=Anton" +
    "&family=Inter:wght@400;600;700" +
    "&family=DM+Sans:wght@400;600;700" +
    "&family=Plus+Jakarta+Sans:wght@400;600;700;800" +
    "&display=swap";
  document.head.appendChild(link);
}
